<template>
<div class="chapter">
<div class="inner_page">
<div class="sgc-toc-title">Table of Contents</div>
<div class="sgc-toc-level-1">
<a href="#/Text/part0004">INTRODUCTION</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/part0005">CHAPTER ONE: TURNABOUT</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/part0006">CHAPTER TWO: BOBBY DEPARTS</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/part0007">CHAPTER THREE: ALIBI</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/part0008">CHAPTER FOUR: ZELLNER FACTOR</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/part0009">CHAPTER FIVE: SKINNY</a>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0010" title="Link target outside of Sample">CHAPTER SIX: AVERY’S PHONE CALL</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0011" title="Link target outside of Sample">CHAPTER SEVEN: COMPUTER BLUES</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0012" title="Link target outside of Sample">CHAPTER EIGHT: BOBBY'S OBSESSIONS</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0013" title="Link target outside of Sample">CHAPTER NINE: SHADY DEPARTMENT</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0014" title="Link target outside of Sample">CHAPTER TEN: RAV4</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0015" title="Link target outside of Sample">CHAPTER ELEVEN: BATHROOM SINK</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0016" title="Link target outside of Sample">CHAPTER TWELVE: BLOOD DOCTOR</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0017" title="Link target outside of Sample">CHAPTER THIRTEEN: TWO CARS</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0018" title="Link target outside of Sample">CHAPTER FOURTEEN: CANINE NOSES</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0019" title="Link target outside of Sample">CHAPTER FIFTEEN: COVER UP</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0020" title="Link target outside of Sample">CHAPTER SIXTEEN: NOTHING THERE</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0021" title="Link target outside of Sample">CHAPTER SEVENTEEN: EVIDENCE PILE</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0022" title="Link target outside of Sample">CHAPTER EIGHTEEN: HOSPITAL STOP</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0023" title="Link target outside of Sample">CHAPTER NINETEEN: SECOND TRY</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0024" title="Link target outside of Sample">CHAPTER TWENTY: GARAGE</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0025" title="Link target outside of Sample">CHAPTER TWENTY-ONE: HEROES OR GOATS?</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0026" title="Link target outside of Sample">CHAPTER TWENTY-TWO: THE CRIME</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0027" title="Link target outside of Sample">CHAPTER TWENTY-THREE: KEN KRATZ</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0028" title="Link target outside of Sample">CHAPTER TWENTY-FOUR: CREEPY KRATZ</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0029" title="Link target outside of Sample">CHAPTER TWENTY-FIVE: COMPUTER DISK</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0030" title="Link target outside of Sample">CHAPTER TWENTY-SIX: FANTASY LIFE</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0031" title="Link target outside of Sample">CHAPTER TWENTY-SEVEN: DAMAGED</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0032" title="Link target outside of Sample">CHAPTER TWENTY-EIGHT: AVERY’S BRAIN</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0033" title="Link target outside of Sample">CHAPTER TWENTY-NINE: BOBBY’S GARAGE</span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0003.vue?a167edfc